
export default {
  name: 'icon-analytics-passenger',
};
